(() => {
 'use strict';
 const config=window.VaultShopifyConfig;
 const views={landing:'vault',model:'vault-model',stack:'vault-stack',assembly:'vault-assembly'};
 function mode(url=new URL(location.href)){return Object.keys(views).find(k=>views[k]===url.searchParams.get('view'))||'landing';}
 function route(kind,params={}){
  const url=new URL(config.pageUrl,location.origin);url.searchParams.set('view',views[kind]||views.landing);
  const current=new URL(location.href);
  for(const key of ['preview_theme_id','_fd','pb'])if(current.searchParams.has(key))url.searchParams.set(key,current.searchParams.get(key));
  Object.entries(params).forEach(([k,v])=>url.searchParams.set(k,v));return url.pathname+url.search;
 }
 function asset(value,group='vault-family-chooser'){
  if(/^(https?:|\/\/|data:|blob:)/.test(value))return value;
  const canonical=new URL(value,'https://vault.local/'+group+'/').pathname.slice(1);
  if(!config.assets[canonical])throw Error('Missing VAULT asset: '+canonical);
  return config.assets[canonical];
 }
 function prepareLinks(){
  document.querySelectorAll('[data-vault-route]').forEach(a=>{
   const url=new URL(a.href,location.href),params=Object.fromEntries(url.searchParams);delete params.view;
   a.href=route(mode(url),params)+url.hash;
  });
 }
 window.VaultShopify={asset,route,mode,prepareLinks};
})();
